import React from "react";
import { Box, Typography } from "@mui/material";
import VisitWarningLabel from "./VisitWarningLabel";
import { getVisitResourceWarningLabels, WarningSeverityValue } from "@caredna-marlin/utils/warnings";
import { GenerateVisitsWarningsMutation } from "~/graphql/__generated__/graphql";

type Props = {
  visitResourceWarning: NonNullable<GenerateVisitsWarningsMutation["generateVisitWarnings"]>["visitResourceWarnings"][number];
  provider: { firstName: string, lastName: string };
};

const VisitResourceWarning: React.FC<Props> = ({ visitResourceWarning, provider }) => {
  const normalizedResourceWarnings = {
    ...Object.fromEntries(Object.entries(visitResourceWarning).map(([k, v]) => [k, v === null ? undefined : v])),
    severity: visitResourceWarning.severity as WarningSeverityValue,
    visitId: visitResourceWarning.visitId,
    providerId: visitResourceWarning.providerId,
  };
  const labels = getVisitResourceWarningLabels(normalizedResourceWarnings)

  if (!labels.length) return null;

  return (
    <Box sx={{ my: 2, maxHeight: 200, overflowY: "auto" }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {provider.firstName} {provider.lastName}:
      </Typography>

      <VisitWarningLabel labels={labels}></VisitWarningLabel>
    </Box>
  );
};

export default VisitResourceWarning;
